import { useCallback, useRef, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Box, Toolbar } from "@mui/material";
import MyFooter from "../components/Layout/MyFooter";
import AuthModal from "../components/Auth/AuthModal";
import ResponsiveAppBar from "../components/Layout/Nav/ResponsiveAppBar";
import ScrollToTop from "../components/ui/ScrollToTop";
import ModalImage from "../assets/modalimage.jpg"
export default function MainOutlet() {
  const [showAuth, setShowAuth] = useState(false);
  const [authTab, setAuthTab] = useState("login");
  const pendingActionRef = useRef(null);

  const { pathname } = useLocation();
  const isHome = pathname === "/";

  const openAuth = useCallback((tab = "login", onSuccess) => {
    setAuthTab(tab);
    pendingActionRef.current =
      typeof onSuccess === "function" ? onSuccess : null;
    setShowAuth(true);
  }, []);

  const handleLoginSuccess = useCallback(() => {
    setShowAuth(false);
    const action = pendingActionRef.current;
    pendingActionRef.current = null;
    if (action) setTimeout(action, 0);
  }, []);

  return (
    <Box
      sx={{
        minHeight: "100dvh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <ResponsiveAppBar openAuth={openAuth} />
      {!isHome && <Toolbar variant="dense" />} 
      <ScrollToTop />

      <Box component="main" sx={{ pt: 0, flexGrow: 1, pb: 2 }}>
        <Outlet context={{ openAuth }} />
        <AuthModal
          show={showAuth}
          onHide={() => setShowAuth(false)}
          tab={authTab}
          setTab={setAuthTab}
          onLoginSuccess={handleLoginSuccess}
          imageSrc={ModalImage}
        />
      </Box>
      <MyFooter />
    </Box>
  );
}
